import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=c97cb722&scoped=true&"
import script from "./PagesList.vue?vue&type=script&lang=js&"
export * from "./PagesList.vue?vue&type=script&lang=js&"
import style0 from "./PagesList.vue?vue&type=style&index=0&id=c97cb722&lang=scss&scoped=true&"
import style1 from "./PagesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97cb722",
  null
  
)

export default component.exports